module.exports = __webpack_public_path__ + "img/medal-bronze.462858cd.svg";